// Zentrale Reducer-Liste.
//
// Sie ist die EINZIGE Stelle, an der die Slices der Anwendung aufgezaehlt werden.
// Der Haupt-Store (src/app/store.js) und der Widget-Store
// (ibe_searchwidget/widget-store.js) bauen beide hierauf auf. Wer einen Slice
// ergaenzt, ergaenzt ihn hier - und das Widget kennt ihn automatisch.
//
// Hintergrund: Das Widget hatte frueher eine handgeschriebene Kopie der Slices.
// Die lief dem Client davon; zuletzt fehlte der filter-Slice und die
// Reisenden-Auswahl stuerzte im WordPress-Widget ab.
import systemReducer from "../reducers/systemSlice.js";
import propertiesReducer from "../reducers/propertiesSlice";
import searchReducer from "../reducers/searchSlice";
import hotelReducer from "../reducers/hotelSlice";
import offersReducer from "../reducers/offersSlice";
import filterReducer from "../reducers/filterSlice";
import bookingReducer from "../reducers/bookingSlice";
import flightReducer from "../reducers/flightSlice";
import languageReducer from "../reducers/languageSlice";
import cacheReducer from "../reducers/cacheSlice";
import eventFlowReducer from "../reducers/eventFlowSlice";
import individualSearchReducer from "../reducers/individualSearchSlice";

import { configurationReducers } from "../reducers/configuartionSlice";

export const rootReducer = {
  ...configurationReducers,
  system: systemReducer,
  properties: propertiesReducer,
  search: searchReducer,
  hotel: hotelReducer,
  cache: cacheReducer,
  eventFlow: eventFlowReducer,
  individualSearch: individualSearchReducer,
  offers: offersReducer,
  filter: filterReducer,
  booking: bookingReducer,
  flight: flightReducer,
  language: languageReducer,
};

// Gleiche Middleware-Einstellungen fuer Client und Widget.
export const storeMiddleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  });
